import React from 'react';
import { Dropdown } from 'antd';
import PropTypes from 'prop-types';
import { notifiYesImg, notifiNoImg } from 'theme/icon';
import Popup from './popup';

import styles from './styles.scss';

export default class TenderSubscribe extends React.PureComponent {
  static propTypes = {
    tenderId: PropTypes.number.isRequired,
    data: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  renderDropdown = () => {
    const {
      data: { subscribe, other },
      tenderId,
    } = this.props;
    return <Popup subscribe={subscribe} handleClickOutside={this.hide} other={other} tenderId={tenderId} />;
  };

  // handleVisibleChange = visible => {
  //   this.setState({ visible });
  // };

  render() {
    const {
      data: { subscribe, isSubscribe },
    } = this.props;
    const NotifyImg = isSubscribe ? notifiYesImg : notifiNoImg;
    return (
      // <Popover
      //   content={
      //     <Popup
      //       subscribe={subscribe}
      //       handleClickOutside={this.hide}
      //       other={other}
      //       tenderId={tenderId}
      //       hide={this.hide}
      //     />
      //   }
      //   trigger="click"
      //   visible={this.state.visible}
      //   onVisibleChange={this.handleVisibleChange}
      //   placement="bottomLeft"
      // >
      //   <div className={styles.popoverButton}>
      //     <promo src={isSubscribe ? notifiYesImg : notifiNoImg} alt="" />
      //     <span>{subscribe.length}</span>
      //   </div>
      // </Popover>

      <div className={styles.popoverButtonContainer}>
        <Dropdown
          dropdownRender={this.renderDropdown}
          // open={this.state.visible}
          trigger={['click']}
          placement="bottomLeft"
        >
          <div className={styles.popoverButton}>
            <NotifyImg alt="" className={styles.icon} />
            <span>{subscribe.length}</span>
          </div>
        </Dropdown>
      </div>
    );
  }
}
